/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  singaporefinishedDescription: {
    defaultMessage: `Well done, you will be notified of your favorite sport planets`,
    id: 'app.singaporefinished.description'
  },
  singaporefinishedButton: {
    defaultMessage: 'Restart',
    id: 'app.singaporefinished.button'
  }
});



// WEBPACK FOOTER //
// ./src/containers/singaporefinished/messages.js